import React from "react";
import "./TwoBanners.scss";
import { Link } from "react-router-dom";

const TwoBanners = ({ data }) => {
  return (
    <div className="twoBanners__">
      {data?.map((v, index) => {
        return (
          <Link to={v?.url} className="bannerLink__" key={"LO" + index}>
            <div className="banner__">
              <img src={v?.src} alt="" />
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default TwoBanners;
